
define('text!gameday-index-mlbtv/src/templates/mlb-tv-link.mustache',[],function () { return '<a href="http://mlb.mlb.com/mlb/subscriptions/index.jsp?product=mlbtv&affiliateId=ATBAT">Watch</a>\n';});

